// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-input {
    padding: 6px;
    font-size: 20px;
    border-width: 0px;
    border-color: #CCCCCC;
    background-color: #FFFFFF;
    color: #000000;
    border-style: solid;
    border-radius: 0px;
    box-shadow: 1px 0px 5px rgba(66,66,66,.60);
    text-shadow: -50px 0px 0px rgba(66,66,66,.0);
    margin-top:30px;
    margin-bottom: 30px;
}
.css-input:focus {
    padding: 6px;
    font-size: 20px;
    border-width: 0px;
    border-color: #CCCCCC;
    background-color: #FFFFFF;
    color: #000000;
    border-style: solid;
    border-radius: 0px;
    box-shadow: 1px 0px 5px rgba(128, 106, 106, 0.6);
    text-shadow: -50px 0px 0px rgba(66,66,66,.0);
}




.left-side{
    width : 50%;
    float:left;

}

.right-side{
    width : 50%;
    float:right;
    
}
.decl-box{
   
        border-top-left-radius: 37px 120px;
        border-top-right-radius: 23px 110px;
        border-bottom-left-radius: 110px 19px;
        border-bottom-right-radius: 120px 24px;
      
        display: block;
        position: relative;
        border: solid 3px #6e7491;
        padding: 40px 60px;
        max-width: 800px;
        width: 90%;
        margin: 100px auto 0;
        font-size: 17px;
        line-height: 28px;
        transform: rotate(-1deg);
        box-shadow: 3px 15px 8px -10px rgba(0, 0, 0, 0.3);
        transition: all 0.13s ease-in;
        height:600px;
      
}





/* CSS */
.button-12 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px 14px;
  font-family: -apple-system, BlinkMacSystemFont, 'Roboto', sans-serif;
  border-radius: 6px;
  border: none;

  background: #6E6D70;
  box-shadow: 0px 0.5px 1px rgba(0, 0, 0, 0.1), inset 0px 0.5px 0.5px rgba(255, 255, 255, 0.5), 0px 0px 0px 0.5px rgba(0, 0, 0, 0.12);
  color: #DFDEDF;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.button-12:focus {
  box-shadow: inset 0px 0.8px 0px -0.25px rgba(255, 255, 255, 0.2), 0px 0.5px 1px rgba(0, 0, 0, 0.1), 0px 0px 0px 3.5px rgba(58, 108, 217, 0.5);
  outline: 0;
}


.file-card{
    /*background-color: rgba(1, 1, 1, 0.15);*/
    margin-bottom: 5%;
    height: 100px;
    width : 1000px;
    max-height:100%;
    max-width: 100%;
    color: black;  
    border-radius: 10px;
}


.file-card-content{
    float:left;
    width:30%;
    margin-top:20px;
    margin-left:20px;
    max-width: 50%;
    max-height: 100px;
    text-align: start;
    position: absolute;
    ruby-position: right;
}

`, "",{"version":3,"sources":["webpack://./src/components/downloadable/downloadable.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,4CAA4C;IAC5C,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,gDAAgD;IAChD,4CAA4C;AAChD;;;;;AAKA;IACI,WAAW;IACX,UAAU;;AAEd;;AAEA;IACI,WAAW;IACX,WAAW;;AAEf;AACA;;QAEQ,kCAAkC;QAClC,mCAAmC;QACnC,qCAAqC;QACrC,sCAAsC;;QAEtC,cAAc;QACd,kBAAkB;QAClB,yBAAyB;QACzB,kBAAkB;QAClB,gBAAgB;QAChB,UAAU;QACV,oBAAoB;QACpB,eAAe;QACf,iBAAiB;QACjB,wBAAwB;QACxB,iDAAiD;QACjD,6BAA6B;QAC7B,YAAY;;AAEpB;;;;;;AAMA,QAAQ;AACR;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,oEAAoE;EACpE,kBAAkB;EAClB,YAAY;;EAEZ,mBAAmB;EACnB,mIAAmI;EACnI,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,6IAA6I;EAC7I,UAAU;AACZ;;;AAGA;IACI,yCAAyC;IACzC,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,eAAe;IACf,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;;AAGA;IACI,UAAU;IACV,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB","sourcesContent":[".css-input {\n    padding: 6px;\n    font-size: 20px;\n    border-width: 0px;\n    border-color: #CCCCCC;\n    background-color: #FFFFFF;\n    color: #000000;\n    border-style: solid;\n    border-radius: 0px;\n    box-shadow: 1px 0px 5px rgba(66,66,66,.60);\n    text-shadow: -50px 0px 0px rgba(66,66,66,.0);\n    margin-top:30px;\n    margin-bottom: 30px;\n}\n.css-input:focus {\n    padding: 6px;\n    font-size: 20px;\n    border-width: 0px;\n    border-color: #CCCCCC;\n    background-color: #FFFFFF;\n    color: #000000;\n    border-style: solid;\n    border-radius: 0px;\n    box-shadow: 1px 0px 5px rgba(128, 106, 106, 0.6);\n    text-shadow: -50px 0px 0px rgba(66,66,66,.0);\n}\n\n\n\n\n.left-side{\n    width : 50%;\n    float:left;\n\n}\n\n.right-side{\n    width : 50%;\n    float:right;\n    \n}\n.decl-box{\n   \n        border-top-left-radius: 37px 120px;\n        border-top-right-radius: 23px 110px;\n        border-bottom-left-radius: 110px 19px;\n        border-bottom-right-radius: 120px 24px;\n      \n        display: block;\n        position: relative;\n        border: solid 3px #6e7491;\n        padding: 40px 60px;\n        max-width: 800px;\n        width: 90%;\n        margin: 100px auto 0;\n        font-size: 17px;\n        line-height: 28px;\n        transform: rotate(-1deg);\n        box-shadow: 3px 15px 8px -10px rgba(0, 0, 0, 0.3);\n        transition: all 0.13s ease-in;\n        height:600px;\n      \n}\n\n\n\n\n\n/* CSS */\n.button-12 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 6px 14px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Roboto', sans-serif;\n  border-radius: 6px;\n  border: none;\n\n  background: #6E6D70;\n  box-shadow: 0px 0.5px 1px rgba(0, 0, 0, 0.1), inset 0px 0.5px 0.5px rgba(255, 255, 255, 0.5), 0px 0px 0px 0.5px rgba(0, 0, 0, 0.12);\n  color: #DFDEDF;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n}\n\n.button-12:focus {\n  box-shadow: inset 0px 0.8px 0px -0.25px rgba(255, 255, 255, 0.2), 0px 0.5px 1px rgba(0, 0, 0, 0.1), 0px 0px 0px 3.5px rgba(58, 108, 217, 0.5);\n  outline: 0;\n}\n\n\n.file-card{\n    /*background-color: rgba(1, 1, 1, 0.15);*/\n    margin-bottom: 5%;\n    height: 100px;\n    width : 1000px;\n    max-height:100%;\n    max-width: 100%;\n    color: black;  \n    border-radius: 10px;\n}\n\n\n.file-card-content{\n    float:left;\n    width:30%;\n    margin-top:20px;\n    margin-left:20px;\n    max-width: 50%;\n    max-height: 100px;\n    text-align: start;\n    position: absolute;\n    ruby-position: right;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
